import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IEntity } from "src/models/Stores/Store.models";

interface EntityState {
  entities: IEntity[];
  entityToEdit: IEntity | null;
}

const initialState: EntityState = {
  entities: [],
  entityToEdit: null,
};

const entitySlice = createSlice({
  name: "Entity",
  initialState,
  reducers: {
    setEntityList: (state, action: PayloadAction<IEntity[]>) => {
      state.entities = action.payload;
    },
    concatListEntity: (
      state: EntityState,
      action: PayloadAction<IEntity[]>
    ) => {
      state.entities = [...state.entities.concat(action.payload)];
    },
    setEntityToEdit: (state, action: PayloadAction<IEntity | null>) => {
      state.entityToEdit = action.payload;
    },
    addEntity: (state, action: PayloadAction<IEntity>) => {
      state.entities.push(action.payload);
    },
    updateEntity: (state, action: PayloadAction<IEntity>) => {
      let itemIndex = state.entities.findIndex(
        item => item.entityId === action.payload.entityId
      );
      if (itemIndex !== -1) state.entities[itemIndex] = action.payload;
    },
    deleteEntity: (state, action: PayloadAction<number>) => {
      const newArray = state.entities.filter(
        item => item.entityId !== action.payload
      );
      state.entities = newArray;
    },
  },
});

export const {
  setEntityList,
  concatListEntity,
  setEntityToEdit,
  addEntity,
  updateEntity,
  deleteEntity,
} = entitySlice.actions;

export default entitySlice.reducer;
